import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export enum STORAGE_KEY {
  CURRENT_USER = 'CURRENT_USER',
  TOKEN = 'TOKEN',
  TRUSTED_DEVICE_REGISTERED = 'TRUSTED_DEVICE_REGISTERED',
  XCMID = 'XCMID',
}

export interface StorageObject {
  key: STORAGE_KEY;
  value: any;
}

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  storageChange = new Subject<StorageObject>();

  constructor() {}

  setItem(key: STORAGE_KEY, value: any): void {
    
    // TRUSTED_DEVICE_REGISTERED.
    if (key !== undefined && value !== undefined) {
      sessionStorage.setItem(key, JSON.stringify(value));
      this.storageChange.next({ key, value });
    }
  }

  getItem(key: STORAGE_KEY) {
    try {
      return JSON.parse(sessionStorage.getItem(key));
    } catch (e) {
      return '';
    }
  }

  removeItem(key: STORAGE_KEY): void {
    sessionStorage.removeItem(key);
    this.storageChange.next({ key, value: null });
  }

  revmoveAll(): void {
    sessionStorage.clear();
    localStorage.clear();
  }
}
